import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  errorRoot: {
    position: 'fixed',
    bottom: 50,
    background: 'white',
    right: 50,
    zIndex: 100
  }
}));

function ErrorModal({ error }) {
  const [show, setShow] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    setShow(!!error);
    setTimeout(() => {
      setShow(false);
    }, 7000);
  }, [error]);

  if (!show) return false;
  if (!error) return false;
  var message = undefined;
  console.log('LESS', JSON.stringify(error));
  if (error.graphQLErrors && error.graphQLErrors.length >= 1) {
    message =
      error.graphQLErrors[0]?.extensions?.message ??
      error.graphQLErrors[0]?.message;
  }

  if (!message) {
    message = error.message;
  }
  return (
    <Card className={classes.errorRoot}>
      <CardContent>
        <Typography>{message}</Typography>
      </CardContent>
    </Card>
  );
}

export default ErrorModal;
